import React, { useEffect, useState } from 'react';
import './compensation.scss';
// import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
// import Input from '../../components/Input/Input';
import { useSelector } from 'react-redux';
import base from '../../apis';
// import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner/Spinner';
import { formatNumber } from '../../utils/functions';

const Compensation = () => {
  const [detailsModal, setDetailsModal] = useState(false);
  const [isLeftOpen, setIsLeftOpen] = useState(false);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  let date = new Date();
  let currentMonth = months[date.getMonth()];
  const marketer_id = useSelector((state) => state.auth?.marketerDetails?.id);
  const [isLoading, setIsLoading] = useState(false);
  const [compensation, setCompensation] = useState({
    sum_of_first_compensation: null,
    sum_of_monthly_commision: null,
    first_compensation_count: 0,
    monthly_commision_count: 0,
  });

  const [agentLists, setAgentLists] = useState([]);
  const isInternational = useSelector((state) => state.auth.marketerDetails.category === 'international');

  useEffect(() => {
    if (!marketer_id) return;
    setIsLoading(true);
    const urls = [
      `/compensations/get-compensation-amount/?marketer_id=${marketer_id}`,
      `compensations/marketers-compensation-view/?marketer_id=${marketer_id}`,
    ];
    Promise.all(urls.map((url) => base.get(url)))
      .then((data) => {
        // console.log(data);
        setCompensation(data[0].data);
        const list = data[1].data;
        const options = list.map((item) => item.package);
        const newOptions = [...new Set(options)];
        // console.log(newOptions);
        const display = newOptions.map((item) => ({
          name: item.split('-').join(' '),
          subs: list.filter((i) => i.package === item),
        }));
        setAgentLists(display);
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, [marketer_id]);

  const [selectedSub, setSelectedSub] = useState(null);

  const handleClick = (name, sub) => {
    const toSub = {
      packageName: name,
      agentName: `${sub.agent.user.first_name} ${sub.agent.user.last_name}`,
      agentEmail: sub.agent.user.email,
      date: sub.subscription.current_period_start,
      // agent
    };
    setSelectedSub(toSub);
    setDetailsModal(true);
  };

  return (
    <>
      {isLoading && <Spinner />}
      <div className="compensation_page">
        <Modal open={detailsModal} onClose={() => setDetailsModal(false)}>
          <div className="mod2" style={{ maxWidth: '70vw' }}>
            <div className="mod2header">
              <div>
                <p style={{ textTransform: 'capitalize' }}>{selectedSub?.packageName}</p>
              </div>
              <CloseIcon
                onClick={() => setDetailsModal(false)}
                style={{ fill: '#1378A5', cursor: 'pointer' }}
                width="18px"
                height="18px"
              />{' '}
            </div>
            <div className="bigg">
              <div>
                <p>
                  Agent's Name: <b>{selectedSub?.agentName}</b>
                </p>

                <p>
                  Agent's Email: <b>{selectedSub?.agentEmail}</b>
                </p>
              </div>
              <div>
                <p>
                  Subscription: <b style={{ textTransform: 'capitalize' }}>{selectedSub?.packageName}</b>
                </p>
                <p>
                  Current Start Date: <b>{new Date(selectedSub?.date).toDateString()}</b>
                </p>
              </div>
            </div>
          </div>
        </Modal>
        <div className="main_content" style={{ width: isLeftOpen ? '75%' : '100%' }}>
          <p
            className="left_opener"
            onClick={() => setIsLeftOpen((v) => !v)}
            title="Click to toggle compensation details">
            Compensation Details
          </p>
          <div className="current_month">
            <p>Current Month - {currentMonth} </p>
          </div>
          <div className="monthly_cost">
            <p className="total_value">Total Value: </p>
            <p className="total_amount">
              $ {formatNumber(compensation?.sum_of_first_compensation + compensation?.sum_of_monthly_commision || 0)}
            </p>
          </div>
          <div className="subscriptions">
            <div className="subscription1">
              <p className="subscription_value">{compensation?.first_compensation_count}</p>
              <span className="subscription_info">{'Subscription Orders'}</span>
              <div className="dot"></div>
              <div className="vertical_rule"></div>
              <div className="amount_wrapper">
                <span className="total">Total</span>
                <span className="amount">$ {formatNumber(compensation?.sum_of_first_compensation || 0)}</span>
              </div>
            </div>
            <div className="subscription1">
              <p className="subscription_value">{compensation?.monthly_commision_count}</p>
              <span className="subscription_info">
                Active Subscriptions {isInternational ? '+ Appointment Commission' : ''}
              </span>
              <div className="dot"></div>
              <div className="vertical_rule"></div>
              <div className="amount_wrapper">
                <span className="total">Total</span>
                <span className="amount">$ {formatNumber(compensation?.sum_of_monthly_commision || 0)}</span>
              </div>
            </div>
            <div className="subscription1">
              <p className="subscription_value">{'0'}</p>
              <span className="subscription_info">{'Decades of Monthly Subscriptions'}</span>
              <div className="dot"></div>
              <div className="vertical_rule"></div>
              <div className="amount_wrapper">
                <span className="total">Total</span>
                <span className="amount">$ 0.00</span>
              </div>
            </div>
          </div>

          <div className="subscription_orders">
            <p>Subscription Orders</p>
          </div>
          {agentLists.map((item, index) => (
            <React.Fragment key={item.name}>
              <p className="blue1">{item.name}</p>
              {item.subs.map((ag) => (
                <SubscriptionCard
                  key={ag.id}
                  name={`${ag.agent?.user.first_name} ${ag.agent?.user.last_name}`}
                  add={ag.agent?.user.email}
                  date={new Date(ag?.subscription?.current_period_start).toDateString()}
                  onClick={() => handleClick(item.name, ag)}
                />
              ))}
            </React.Fragment>
          ))}
        </div>
        {isLeftOpen && (
          <div className="right_side_content">
            <div className="side_info">
              <div className="side_info_wrapper">
                <p className="cost cost_title">BPO Farm</p>
                <p>
                  <span className="cost">$ 200</span>
                  <br />
                  <span className="cost_info">upon signup</span>
                </p>
                <p className="payment_info">
                  <span>Paid after 1st Monthly payment is recieved</span>
                </p>
                <p>
                  <span className="cost">$ 20</span>
                  <br />
                  <span className="cost_info">Monthly residual for active Subscriptions</span>
                </p>
              </div>
            </div>
            <div className="side_info">
              <div className="side_info_wrapper">
                <p className="cost cost_title">Deal Analyzer</p>
                <p>
                  <span className="cost">$ 30</span>
                  <br />
                  <span className="cost_info">upon signup</span>
                </p>

                <p>
                  <span className="cost">$ 5</span>
                  <br />
                  <span className="cost_info">Monthly residual for active Subscriptions</span>
                </p>
              </div>
            </div>
            <div className="side_info">
              <div className="side_info_wrapper">
                <p className="cost cost_title">Premier agent website</p>
                <p>
                  <span className="cost">$ 20</span>
                  <br />
                  <span className="cost_info">upon signup</span>
                </p>

                <p>
                  <span className="cost">$ 5</span>
                  <br />
                  <span className="cost_info">Monthly residual for active Subscriptions</span>
                </p>
              </div>
            </div>
            <div className="side_info">
              <div className="side_info_wrapper">
                <p>
                  <span className="cost">$ 300</span>
                  <br />
                  <span className="cost_info">Additional bonus per 10 subscription monthly</span>
                </p>
                <p>
                  <span className="cost">$ 100k</span>
                  <br />
                  <span className="cost_info">Cap on residual</span>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Compensation;

const SubscriptionCard = ({ onClick, name, add, date }) => {
  return (
    <div className="subscriptions_wrapper" onClick={onClick}>
      <div className="card">
        <p>{name}</p>
        <p>{add}</p>
        <p>{date}</p>
      </div>
    </div>
  );
};
